import styled from 'styled-components';

import { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';

import COLORS from '@ui-component-library/styles/colors';
import { TEXTAREA_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Wrapper: styled.div<{
    variant: 'default' | 'fluid';
    disabled: boolean;
  }>`
    ${TEXTAREA_RESET}

    width: 100%;
    opacity: ${(props) => (props.disabled ? 0.6 : 1)};
    position: relative;
  `,

  TopSection: styled.div`
    padding-bottom: ${SPACING.size8};
    display: flex;
    flex-direction: column;
    gap: ${SPACING.size4};
  `,

  Label: styled.label`
    ${TYPOGRAPHY.labelMediumRegularDense}
    color: ${COLORS['charcoal-500']};
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
  `,

  FluidLabel: styled.label<{ $isFloating?: boolean }>`
    ${({ $isFloating }) =>
      $isFloating ? TYPOGRAPHY.labelXtraSmallRegular : TYPOGRAPHY.labelMediumMedium};
    color: ${COLORS['charcoal-500']};
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
    transition: all 0.2s ease;
    position: absolute;
    left: 16px;

    top: ${({ $isFloating }) => ($isFloating ? '6px' : '28px')};
    transform: ${({ $isFloating }) => ($isFloating ? 'translateY(0)' : 'translateY(-50%)')};
  `,

  FluidLabelIcon: styled.div`
    padding-left: ${SPACING.size4};
    display: flex;
    align-items: center;
  `,

  Description: styled.p`
    ${TYPOGRAPHY.overlineMediumRegular}
    color: ${COLORS['cloud-900']};
  `,

  TextareaContainer: styled.div<{
    $state: 'success' | 'error' | 'idle' | 'disabled';
  }>`
    border-radius: 12px;
    border: 1px solid
      ${(props) => {
        switch (props.$state) {
          case 'success':
            return COLORS['success-900'];
          case 'error':
            return COLORS['danger-500'];
          case 'disabled':
          case 'idle':
            return COLORS['charcoal-alpha-50'];
        }
      }};

    background-color: ${COLORS['white-50']};
    padding: ${SPACING.size16} 0 ${SPACING.size16} ${SPACING.size16};
    display: flex;
    align-items: flex-start;
    margin-bottom: ${SPACING.size8};
  `,

  Textarea: styled.textarea<{
    $isFluid?: boolean;
  }>`
    ${TYPOGRAPHY.labelMediumMedium}
    resize: none !important;
    flex: 1;
    border: 0;
    background: transparent;
    text-overflow: ellipsis;
    color: ${COLORS['charcoal-500']};

    width: 100%;
    min-height: ${(props) => (props.$isFluid ? '42px' : 'auto')};
    margin-top: ${(props) => (props.$isFluid ? '12px' : '0')};

    &::placeholder {
      color: ${COLORS['charcoal-300']};
    }

    &:focus-visible {
      outline: none;
      border: 0;
    }
  `,

  SuffixWrapper: styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-left: auto;
  `,

  Button: styled.button`
    border: none;
    background: none;
    padding: ${SPACING.size12} ${SPACING.size16};
    cursor: pointer;
    display: flex;
    align-items: center;
  `,

  IconWrapper: styled.div`
    padding: ${SPACING.size12} ${SPACING.size16};
    display: flex;
    align-items: center;
  `,

  BottomSection: styled.div`
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
    padding-left: ${SPACING.size12};
    height: 12px;
  `,

  HelperText: styled.p<{ $validationState: 'success' | 'error' | 'idle' }>`
    ${TYPOGRAPHY.labelXtraSmallRegular}
    color: ${(props) => {
      switch (props.$validationState) {
        case 'success':
          return COLORS['success-900'];
        case 'error':
          return COLORS['danger-500'];
        default:
          return COLORS['pebble-500'];
      }
    }};
  `
};
